module.exports = __webpack_public_path__ + "static/Photo1-981ebf0f971e92dff3d39854621848a8.jpg";